// « 16 – 17 oct. 2026 » d'après une liste de jours d'événement [{ date, label }] ; vide tant qu'aucune
// date n'est définie. Partagé par l'écran de config et les formulaires publics.
const at = (iso) => new Date(`${iso}T12:00`);
const WITH_YEAR = { day: 'numeric', month: 'short', year: 'numeric' };

export const eventDatesLabel = (days) => {
  const dates = (days || []).map((d) => d.date).filter(Boolean).sort();
  if (dates.length === 0) return '';
  const first = dates[0];
  const last = dates[dates.length - 1];
  if (first === last) return at(first).toLocaleDateString('fr-FR', WITH_YEAR);
  const sameMonth = first.slice(0, 7) === last.slice(0, 7);
  const start = sameMonth ? at(first).getDate() : at(first).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  return `${start} – ${at(last).toLocaleDateString('fr-FR', WITH_YEAR)}`;
};

export default eventDatesLabel;
